import React from "react";
import GuidePanel from "../GuidePanel.js";
import {
  GuideLead,
  GuideCallout,
  GuideSectionLabel,
  GuideCard,
  GuideCardGrid,
} from "../GuideBlocks.js";
import { getEmotionIcon } from "../../../constants/emotionIcons.js";

const EMOTIONS = [
  { key: "disappointed", label: "Disappointed" },
  { key: "hurt", label: "Hurt" },
  { key: "embarrassed", label: "Embarrassed" },
  { key: "anxious", label: "Anxious" },
  { key: "lonely", label: "Lonely" },
  { key: "jealous", label: "Jealous" },
  { key: "guilty", label: "Guilty" },
  { key: "ashamed", label: "Ashamed" },
  { key: "frustrated", label: "Frustrated" },
  { key: "overwhelmed", label: "Overwhelmed" },
  { key: "hopeful", label: "Hopeful" },
  { key: "excited", label: "Excited" },
  { key: "grateful", label: "Grateful" },
];

const NamingEmotionsSection = ({ heading, accentIndex = 3, getVisual, getAccent }) => (
  <GuidePanel
    sectionId="naming-emotions"
    heading={heading}
    accentIndex={accentIndex}
    getVisual={getVisual}
    getAccent={getAccent}
  >
    <GuideLead>
      Many people describe every uncomfortable feeling as either stress or anger. But emotions are
      much more specific. Learning to name emotions increases emotional clarity.
    </GuideLead>
    <p className="guide-panel__p">Instead of saying, "I feel bad," ask yourself whether you feel:</p>
    <GuideSectionLabel>Common emotions</GuideSectionLabel>
    <GuideCardGrid columns={3}>
      {EMOTIONS.map((emotion) => (
        <GuideCard
          key={emotion.key}
          variant="emotion"
          iconSrc={getEmotionIcon(emotion.key)}
          title={emotion.label}
        />
      ))}
    </GuideCardGrid>
    <p className="guide-panel__p">
      The more accurately you name an emotion, the easier it becomes to identify the interpretation behind it.
    </p>
    <GuideCallout>
      Feeling overwhelmed may point to too many open decisions. Feeling anxious may point to an untested
      prediction. Feeling guilty may point to a rule you have never examined. Name the emotion, then look
      at the thought underneath it.
    </GuideCallout>
    <GuideCallout variant="amber">Naming emotions turns confusion into clarity.</GuideCallout>
  </GuidePanel>
);

export default NamingEmotionsSection;
